import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";

const apiUrl = process.env.REACT_APP_API_URL;

// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Fraudster’s Information",
    description: "Answer the set of questions about Fraudster/Suspect.",
    continue: "Continue",
  },
  Hi: {
    header: "धोखेबाज़ की जानकारी",
    description: "धोखेबाज़ / संदिग्ध के बारे में प्रश्नों के उत्तर दें।",
    continue: "जारी रखें",
  },
  Kn: {
    header: "ವಂಚಕರ ವಿವರಗಳು",
    description: "ವಂಚಕರ ಬಗೆಗಿನ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ.",
    continue: "ಮುಂದೆ ಸಾಗು",
  },
};

const Suspect = ({ onNext, onQuestion,selectedLang }) => {
  const [isPlaying, setIsPlaying] = useState(false); // Track audio play status
  const audioRef = useRef(null);

  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/suspect.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio13.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio13.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };

  // When the selected language changes, update the audio element's source automatically
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  const handleContinue = () => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    // Call onNext and onQuestion to move forward
    onNext(13);
    onQuestion(14);
    localStorage.setItem("support", JSON.stringify("support"));
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h2>{translations[selectedLang].header}</h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
            </button>
            <audio ref={audioRef} onEnded={handleAudioEnd}>
              <source src={audioMap[selectedLang]} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </div>
          <p className="suspect-para">{translations[selectedLang].description}</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button type="button" className="continue-btn" onClick={handleContinue}>
              {translations[selectedLang].continue}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Suspect;
